import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DevelopmentalRubricSkeleton from "../../../../../../skeleton/DevelopmentalRubricSkeleton";
import FormGranularStepsPreview from "../../FormGranularStepsPreview/FormGranularStepsPreview";
import useMarking from "../../../../../../../hooks/maestro/useMarking";
import { updateBulkMarkingGranularSteps } from "../../../../../../../store/actions/class-marking.actions";

const LcsData = ({ isLoading }) => {
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {}
  const lcsIds = useSelector((state) => state?.classMarking.lcsIds || []);
  const lcs = useSelector((state) => state?.classMarking?.lcs || []);
  const logMarking = useSelector((state) => state?.classMarking?.logMarking || []);
  const students = useSelector((state) =>
    JSON.parse(JSON.stringify(state?.classMarking?.studentsBulk || []))
  );

  const dispatch = useDispatch();
  const { onSetMarkingGranularSteps, newLogMarking } = useMarking();

  const lcsData = lcs.map((lc) => {
    const granularSteps = lc.granularSteps.map((gs) => {
      let logs = [];
      students.forEach((student) => {
        const lcStudent = student?.lcs?.find((lcs) => lcs._id === lc._id);
        if (lcStudent) {
          const gsStudent = lcStudent?.granularSteps?.find(
            (gss) => gss.id === gs.id
          );

          if (gsStudent) {
            const logsStudent = gsStudent?.logs
              ?.filter(
                (log) => log.markingType === "completedTeacher" && log.exists && log.marking !== minMarking._id
              )
              .map((log) => {
                return {
                  ...log,
                  student: {
                    studentId: student._id,
                    fullName: student.fullName,
                    code: student.code,
                    photo: student.photo,
                  },
                  isBulk: true,
                };
              });
            logs = [...logs, ...logsStudent];
          }
        }
      });

      return {
        ...gs,
        logs,
      };
    });
    return {
      ...lc,
      granularSteps,
    };
  });

  const onSetMarking = (lcId, granularSteps = [], maxLevel) => {
    let newLogs = logMarking;
    const completed = "completedTeacher";
    const gs = onSetMarkingGranularSteps(granularSteps, completed, maxLevel);
    const newLog = newLogMarking(
      'bulk',
      lcId,
      [...granularSteps],
      gs,
      completed,
      'bulk-marking'
    );
    if (newLog.from.length > 0) {
      newLogs.unshift(newLog);
    }
    dispatch(updateBulkMarkingGranularSteps(lcId, gs, logMarking));
  };

  return (
    <div className="absolute top-0 bottom-0 left-200px right-0 overflow-auto">
      {isLoading ? (
        <DevelopmentalRubricSkeleton showHeader={false} />
      ) : (
        <FormGranularStepsPreview
          completed="completedTeacher"
          lcs={lcsData.filter((lc) =>
            lcsIds.length > 0 ? lcsIds.includes(lc._id) : true
          )}
          onSetMarking={onSetMarking}
          isBulk={true}
        />
      )}
    </div>
  );
};

export default LcsData;
